/** Redux Packages. */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    il_opus_reference_id: '',
    il_trade_partner_id_client: '',
    il_team_id: '',
    il_trade_partner_id_forwarder: '',
    mbl: '',
    il_opus_vessel_id: '',
    incoterm: '',
    etd: null,
    eta: null,
    feta: null,
    il_location_id_pol: '',
    il_location_id_pod: '',
    il_location_id_fpod: '',
    il_ocean_import_hbl: [
        {
            id: 1,
            hbl: '',
            il_ocean_import_cntr: [],
            il_trade_partner_id_shipper: '',
            il_trade_partner_id_consignee: '',
            reference: '',
        },
    ],
    parent_id: '',
    rate_copy: false,
};

const oimShipmentFormSlice = createSlice({
    name: 'oimNewShipmentForm',
    initialState,
    reducers: {
        setFormData: (state, action) => {
            return { ...state, ...action.payload };
        },
        addHBL: (state, action) => {
            state.il_ocean_import_hbl = [...state.il_ocean_import_hbl, action.payload];
        },
        deleteHBL: (state, action) => {
            const tabId = action.payload;
            return { ...state, il_ocean_import_hbl: state.il_ocean_import_hbl.filter((hbl) => hbl.id !== tabId) };
        },
        updateHBLtitle: (state, action) => {
            const { id, newTitle } = action.payload;
            state.il_ocean_import_hbl = state.il_ocean_import_hbl.map((item) =>
                item.id === id ? { ...item, hbl: newTitle } : item
            );
        },
        updateHBL: (state, action) => {
            const { id, key, value } = action.payload;
            const index = state.il_ocean_import_hbl.findIndex((hbl) => hbl.id === id);
            if (index !== -1) {
                const hblItem = state.il_ocean_import_hbl[index];

                if (key in hblItem) {
                    state.il_ocean_import_hbl[index][key] = value;
                }
            }
        },
        addContainer: (state, action) => {
            const { hblId, cntr } = action.payload;
            state.il_ocean_import_hbl = state.il_ocean_import_hbl.map((item) =>
                item.id === hblId ? { ...item, il_ocean_import_cntr: [...item.il_ocean_import_cntr, cntr] } : item
            );
        },
        updateContainer: (state, action) => {
            const { hblId, containerId, updatedContainer } = action.payload;
            state.il_ocean_import_hbl = state.il_ocean_import_hbl.map((item) =>
                item.id === hblId
                    ? {
                          ...item,
                          il_ocean_import_cntr: item.il_ocean_import_cntr.map((cntrItem) =>
                              cntrItem.id === containerId ? { ...cntrItem, ...updatedContainer } : cntrItem
                          ),
                      }
                    : item
            );
        },
        deleteContainer: (state, action) => {
            const { hblId, containerId } = action.payload;
            state.il_ocean_import_hbl = state.il_ocean_import_hbl.map((item) =>
                item.id === hblId
                    ? {
                          ...item,
                          il_ocean_import_cntr: item.il_ocean_import_cntr.filter(
                              (cntrItem) => cntrItem.id !== containerId
                          ),
                      }
                    : item
            );
        },
        resetFormData: (state) => {
            return initialState;
        },
    },
});

export const {
    setFormData,
    resetFormData,
    addHBL,
    deleteHBL,
    updateHBLtitle,
    updateHBL,
    addContainer,
    updateContainer,
    deleteContainer,
    setContainerData,
} = oimShipmentFormSlice.actions;
export default oimShipmentFormSlice.reducer;
